export const actions = {
    STORE_NON_PROJECT_OPENED_RECORDS: "STORE_NON_PROJECT_OPENED_RECORDS",
    STORE_NON_PROJECT_PINNED_RECORDS: "STORE_NON_PROJECT_PINNED_RECORDS",
};

export const initialState = {
    opened: [],
    pinned: [],
};

export default (state = initialState, { type, data }) => {
    switch (type) {
        case actions.STORE_NON_PROJECT_OPENED_RECORDS: {
            return {
                ...state,
                opened: data,
            };
        }
        case actions.STORE_NON_PROJECT_PINNED_RECORDS: {
            return {
                ...state,
                pinned: data,
            };
        }

        default:
            return state;
    }
};
